import api from "../utils/api";

const PERMISSIONS_BASE = "/api/authentication/permissions";

export async function getPermissions(params = {}) {
  const response = await api.get(PERMISSIONS_BASE, { params });
  return response.data;
}

export async function getPermission(permissionId) {
  const response = await api.get(`${PERMISSIONS_BASE}/${permissionId}`);
  return response.data;
}

export async function createPermission(payload) {
  const response = await api.post(PERMISSIONS_BASE, payload);
  return response.data;
}

export async function updatePermission(permissionId, payload) {
  const response = await api.put(
    `${PERMISSIONS_BASE}/${permissionId}`,
    payload,
  );

  return response.data;
}

export async function deletePermission(permissionId) {
  const response = await api.delete(
    `${PERMISSIONS_BASE}/${permissionId}`,
  );

  return response.data;
}
